import * as React from "react";
import { observer } from "mobx-react";
import type { PaginationState } from "../../utils/pagination-state";
import { CommandButton, Stack } from "@fluentui/react";
import { type ApiResource } from "../../utils/elofleet-repository";
import { store } from "../../store";

export interface PaginationButtonsProps {
    readonly paginationState: PaginationState<ApiResource>;
}

@observer
export class PaginationButtons extends React.Component<PaginationButtonsProps> {
    public render(): JSX.Element {
        if (this.props.paginationState.paginationNotNeeded) {
            return <></>;
        }

        return (
            <Stack horizontal horizontalAlign="end">
                <CommandButton
                    key="left"
                    onClick={this.props.paginationState.previous}
                    disabled={this.props.paginationState.previousDisabled}
                    iconProps={{ iconName: "ChevronLeft" }}
                />

                <span
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        padding: "0 1ch 0 1ch",
                    }}
                >
                    {store.i18n.t("component.paginationButtons.currentPage", {
                        page: this.props.paginationState.currentPage + 1,
                    })}
                    {` / ${this.props.paginationState.totalPages}`}
                </span>

                <CommandButton
                    key="right"
                    onClick={this.props.paginationState.next}
                    disabled={this.props.paginationState.nextDisabled}
                    iconProps={{ iconName: "ChevronRight" }}
                />
            </Stack>
        );
    }
}
